import { t as outsideComponentT } from 'i18next';
import AccessibilitySwitcher from "helpers/accessibilitySwitcher";
import { selectAccessibilityData } from 'reducers/accessibility';

import CalculatorLogo from 'assets/apply.clevry/Icon_Guide_01.png';
import WatchLogo from 'assets/apply.clevry/Icon_Guide_02.png';
import MobileLogo from 'assets/apply.clevry/Icon_Guide_04.png';
import DesktopLogo from 'assets/apply.clevry/Icon_Guide_05.png';
import CalculatorLogoYellow from 'assets/apply.clevry/Icon_Guide_01_Yellow.png';
import WatchLogoYellow from 'assets/apply.clevry/Icon_Guide_02_Yellow.png';
import MobileLogoYellow from 'assets/apply.clevry/Icon_Guide_04_Yellow.png';
import DesktopLogoYellow from 'assets/apply.clevry/Icon_Guide_05_Yellow.png';
import CalculatorLogoWhite from 'assets/apply.clevry/Icon_Guide_01_White.png';
import WatchLogoWhite from 'assets/apply.clevry/Icon_Guide_02_White.png';
import MobileLogoWhite from 'assets/apply.clevry/Icon_Guide_04_White.png';
import DesktopLogoWhite from 'assets/apply.clevry/Icon_Guide_05_White.png';
import CalculatorLogoBlack from 'assets/apply.clevry/Icon_Guide_01_Black.png';
import WatchLogoBlack from 'assets/apply.clevry/Icon_Guide_02_Black.png';
import MobileLogoBlack from 'assets/apply.clevry/Icon_Guide_04_Black.png';
import DesktopLogoBlack from 'assets/apply.clevry/Icon_Guide_05_Black.png';

export const getBarClassName = (
    percentageComplete: number,
    isCompleted: boolean
  ) => {
    if (!isCompleted && percentageComplete >= 0 && percentageComplete < 100) {
      // return '#2A9A47';
      return '#036C8F';
    } else if (isCompleted || percentageComplete === 100) {
      // return '#f5f5f5';
      return '#2A9A47';
    } else {
      return '#f5f5f5';
    }
  };

export const getHelpIconText = (prongCode: string) => {
    switch (prongCode) {
    case 'PQ':
        return outsideComponentT(
        'SSCandidate_View_Application_Stages_Help_Icon_PQ'
        );
    case 'SJT':
        return outsideComponentT(
        'SSCandidate_View_Application_Stages_Help_Icon_SJT'
        );
    case 'Numerical':
        return outsideComponentT(
        'SSCandidate_View_Application_Stages_Help_Icon_Numerical'
        );
    case 'Verbal':
        return outsideComponentT(
        'SSCandidate_View_Application_Stages_Help_Icon_Verbal'
        );
    case 'Abstract':
        return outsideComponentT(
        'SSCandidate_View_Application_Stages_Help_Icon_Abstract'
        );
    case 'Mechanical':
        return outsideComponentT(
        'SSCandidate_View_Application_Stages_Help_Icon_Mechanical'
        );
    case 'Checking':
        return outsideComponentT(
        'SSCandidate_View_Application_Stages_Help_Icon_Checking'
        );
    default:
        return null;
    }
};

 export const getRequirementsIcons = (
    fullRequirements: { requirement: string }[],
    accessibilityData: any
  ) => {
    const requirementIcons: { [key: string]: string } = {
      Desktop: AccessibilitySwitcher(DesktopLogo, DesktopLogoYellow, DesktopLogoWhite, DesktopLogoBlack, accessibilityData),
      Mobile: AccessibilitySwitcher(MobileLogo, MobileLogoYellow, MobileLogoWhite, MobileLogoBlack, accessibilityData),
      TimeLimit: AccessibilitySwitcher(WatchLogo, WatchLogoYellow, WatchLogoWhite, WatchLogoBlack, accessibilityData),
      Calculator: AccessibilitySwitcher(CalculatorLogo, CalculatorLogoYellow, CalculatorLogoWhite, CalculatorLogoBlack, accessibilityData),
    };
    if (fullRequirements) {
      return fullRequirements.map(
        (requirementWrapper: { requirement: string }) => {
          return (
            <img
              src={requirementIcons[requirementWrapper.requirement]}
              alt={outsideComponentT(
                'SSCandidate_View_Application_Stages_Alt_Requirement_Wrapper_Requirement'
              ) + requirementWrapper.requirement.toLowerCase()}
            />
          );
        }
      );
    }
    return null;
  };
